module.exports = __webpack_public_path__ + "img/menu-board-double-pizza.ca5da0af.webp";